import Icon from '../components/Icon.vue'

Icon.register({
  'vote-yea': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M608 320H544V384H566.4C571.7 384 576 387.6 576 392V408C576 412.4 571.7 416 566.4 416H73.6C68.3 416 64 412.4 64 408V392C64 387.6 68.3 384 73.6 384H96V320H32C14.3 320 0 334.3 0 352V448C0 465.7 14.3 480 32 480H608C625.7 480 640 465.7 640 448V352C640 334.3 625.7 320 608 320zM512 384V64.3C512 46.4 497.5 32 479.7 32H160.4C142.5 32 128 46.5 128 64.3V384H512zM211.2 202L236.7 176.7C240.9 172.5 247.7 172.5 251.9 176.8L293.2 218.4 388.4 124C392.6 119.8 399.4 119.8 403.6 124.1L428.9 149.6C433.1 153.8 433.1 160.6 428.8 164.8L300.5 292C296.3 296.2 289.5 296.2 285.3 291.9L211.2 217.2C206.9 213 207 206.2 211.2 202z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/vote-yea.js
// module id = Gx5A
// module chunks = 144